(() => {
  function initVariantMore(root = document) {
    root.querySelectorAll?.('[data-vc-variant-more]').forEach((button) => {
      if (button.dataset.vcReady === 'true') return;
      button.dataset.vcReady = 'true';
      const fieldset = button.closest('.vc-variant-collapsible');
      if (!fieldset) return;
      const hiddenCount = fieldset.querySelectorAll('label.vc-variant-extra').length;

      const refresh = () => {
        const expanded = fieldset.classList.contains('is-expanded');
        button.textContent = expanded ? '收起口味' : `更多口味 +${hiddenCount}`;
        button.setAttribute('aria-expanded', expanded ? 'true' : 'false');
      };

      button.addEventListener('click', () => {
        fieldset.classList.toggle('is-expanded');
        refresh();
      });
      refresh();
    });
  }

  function init(root = document) {
    initVariantMore(root);
  }

  document.addEventListener('DOMContentLoaded', () => init(document));
  document.addEventListener('shopify:section:load', (event) => init(event.target));
  document.addEventListener('product-info:loaded', (event) => init(event.target));
})();
